import '/modules/common/css/timeseries/container.css';
import '/modules/common/css/timeseries/container.responsive.css';
import '/modules/common/css/timeseries/container.mobile.css';
import {UIElement} from "../ui/ui";
import {Loader} from "../ui/Loader";

/**
 * An abstract container is an element of a report that contains something like a chart or a time selector
 * @abstract
 * @extends UIElement
 */
export class AbstractContainer extends UIElement {

    /**
     *
     * @param id {string} The HTML id for this container
     **/
    constructor(id) {
        super(id, undefined);
    }

    getClassName() {
        return "AbstractContainer";
    }

    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $('<li role="listitem" class="element timeseries-container"></li>');
            const container = this.getContainerElement().attr('id', this.id);
            $('.body',container).attr('id',this.id+'_body').attr('aria-labelledby', this.id+'_title');
            $('header .title',container).attr('id',this.id+'_title');
            this.uiElement.append(container);

            if(this.isCollapsible()) {
                $('.buttons-container button.expander', this.uiElement).attr('aria-controls',this.id+'_body');
                $('.buttons-container button.expander, .header>.title', this.uiElement).click(() => {
                    if (this.isExpanded()) {
                        this.collapse();
                        this.logStat("COLLAPSE");
                    } else {
                        this.expand();
                        this.logStat("EXPAND");
                    }
                });
            }

            this.loader = new Loader('loader_' + this.id, $('.body', container));
        }
        return this.uiElement;
    }

    showLoader(){
        this.loader.show();
        return this;
    }

    hideLoader(){
        this.loader.hide();
        return this;
    }

    /**
     * Generate elements to insert into this container
     * @return {jQuery}
     */
    getContainerElement() {
    }

    isCollapsible(){
        return true;
    }

    /**
     * Is this container expanded?
     * @return {boolean}
     */
    isExpanded() {
        if(!this.isCollapsible())
            return true;
        return this.getSessionProp("expanded") !== false;
    }

    /**
     * Expand container
     */
    expand() {
        this.setSessionProp("expanded", true);
        $('.buttons-container button.expander', this.uiElement)
            .addClass('collapse')
            .removeClass('expand');
        $('.container', this.uiElement).addClass('expanded');
        $('.body', this.uiElement).attr('aria-expanded', 'true');
        this._onExpand();
    }

    /**
     * Collapse container
     */
    collapse() {
        if(this.isCollapsible()) {
            this.setSessionProp("expanded", false);
            $('.buttons-container button.expander', this.uiElement)
                .addClass('expand')
                .removeClass('collapse');
            $('.container', this.uiElement).removeClass('expanded');
            $('.body', this.uiElement).attr('aria-expanded', 'false');
            this._onCollapse();
        }
    }

    /**
     * Override to specify behavior after expand
     */
    _onExpand(){}

    /**
     * Override to specify behavior after collapse
     */
    _onCollapse(){}
}